import React from "react";

import { withStyles } from '@mui/styles';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import LinkRoundedIcon from '@mui/icons-material/LinkRounded';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';

import ArrowTooltipCss from "../../common/ArrowTooltipCss";
import ArrowTooltipComponent from "../../common/ArrowTooltip";
import ComponentWrapper from "../../common/ComponentWrapper";
import CommonStyles from "../../common/CommonStyles";
import GmailRedirect from "../../common/UserTutorialComponents/GmailRedirect";
import YahooRedirect from "../../common/UserTutorialComponents/YahooRedirect";
import OutlookRedirect from "../../common/UserTutorialComponents/OutlookRedirect";
import SylectusRedirect from "../../common/UserTutorialComponents/SylectusRedirect";
import MicrosoftRedirect from "../../common/UserTutorialComponents/MicrosoftRedirect";

const styles = {
  descriptionFont: {
    fontSize: 14,
    marginTop: '10px',
    lineHeight: 2,
  },
  blockLine: {
    backgroundColor: '#ebe4f19e',
    minWidth: '8px',
  },
  linkToBlock: {
    cursor: 'pointer',
    width: 'fit-content',
    borderBottom: '1px dashed #AFAECF',
  },
  providersText: {
    color: '#347CFF',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  iconInfo: {
    marginLeft: '4px',
    fontSize: '12px',
    color: '#347CFF',
    '&:hover': {
      color: '#347CFF !important',
      textDecoration: 'underline',
    },
  },
  ...CommonStyles,
};

class UserTutorialPage extends ComponentWrapper {
  state = {
    openedBlocks: new Set(),
  };

  componentDidMount = () => {
    this.moveToBlock();
  };

  // componentDidUpdate = () => {
  //   this.moveToBlock();
  // };

  moveToBlock = () => {
    const { openedBlocks } = this.state;
    const blockHash = window.location.hash;

    if (blockHash) {
      setTimeout(() => {
        if (!openedBlocks || !openedBlocks.has(blockHash)) this.setState({ openedBlocks : new Set([ ...openedBlocks.add(blockHash)]) });
        this.scrollToSection(blockHash);
      }, 300);
    }
  };

  onBlockChangeClick = (blockName) => {
    const { openedBlocks } = this.state;

    if (!openedBlocks.has(blockName)) {
      openedBlocks.add(blockName);
    } else {
      openedBlocks.delete(blockName);
    }
    this.setState({ openedBlocks: new Set(openedBlocks) });
  };

  scrollToSection = (rstIdToFocus) => {
    if (rstIdToFocus) {
      const el = document.getElementById(rstIdToFocus);

      const yOffset = -60;
      const y = el.getBoundingClientRect().top + window.scrollY + yOffset;

      window.scrollTo({ top: y, behavior: 'smooth' });

      //el.scrollIntoView(true); //block: "start", behavior: "smooth"
    }
  };

  sylectusMessage = () => {
    return (
      <ArrowTooltipComponent title="Email sent by Sylectus to Milkyweb that you can find on the Milkyweb Dashboard in <strong>'Load boards'</strong> instruction section 2.'Loadboard authorization message'">
        <strong>Sylectus email</strong>
        <HelpRoundedIcon style={{ fontSize: '15px', color: '#AFAECF', marginLeft: '4px' }}/>
      </ArrowTooltipComponent>
    )
  };

  autogeneratedMWEmail = () => {
    return (
      <ArrowTooltipComponent title="Autogenerated email that you can find on the your Milkyweb Dashboard page at the left top under greeting: 'Your Milkyweb email forwarding address'.">
        <strong>Milkyweb address for forwarding</strong>
        <HelpRoundedIcon style={{ fontSize: '15px', color: '#AFAECF', marginLeft: '4px' }}/>
      </ArrowTooltipComponent>
    )
  };

  verificationMessage = () => {
    return (
      <ArrowTooltipComponent title="By completion all previously required steps, you can find Verification message on the your Milkyweb Dashboard page in the 'Email forwarding instruction' in the '2. Redirect verification' section.">
        <strong>Redirect verification message</strong>
        <HelpRoundedIcon style={{ fontSize: '15px', color: '#AFAECF', marginLeft: '4px' }}/>
      </ArrowTooltipComponent>
    )
  };

  mwDashboard = () => {
    const { classes } = this.props;
    return (
      <div>
        <a href="/dashboard" target="_blank" rel="noopener noreferrer"
          className={`${classes.providersText} ${classes.pointer}`}
        ><span className={classes.pointer}>Dashboard</span><OpenInNewRoundedIcon className={classes.iconInfo}/></a>
      </div>
    )
  };

  blockTitle = (titleText, blockLink, imageLink) => {
    const { classes } = this.props;
    const { openedBlocks } = this.state;

    return (
      <div className={`${classes.alignCenter} ${classes.mb20}`}>
        <div className={classes.alignCenter} onClick={() => this.onBlockChangeClick(blockLink)}>
          <KeyboardArrowDownRoundedIcon
            className={classes.mr10}
            style={{ transform: `${openedBlocks && blockLink && openedBlocks.has(blockLink) ? 'rotate(180deg)' : ''}` }}
          />

          {imageLink ?
            <img
              className={classes.mr10}
              src={imageLink}
              title="blockLink"
              alt="blockLink"
              style={{
                width: '20px',
                height: 'auto',
              }}
            />
          : null}

          <h5 className={`${classes.linkToBlock} ${classes.mr10}`}>{titleText}</h5>
        </div>
        <ArrowTooltipCss text="Copy link" placement="left"> 
          <LinkRoundedIcon
            className={classes.iconInfo}
            style={{ fontSize: 20, color: '#89A1D6' }} 
            onClick={() => {
              navigator.clipboard.writeText(`${window.location.host}/tutorial${blockLink}`);
              this.notify('info', `Link copied to clipboard`, 3);
            }}
          />
        </ArrowTooltipCss>
      </div>
    )
  };

  render () {
    const { classes } = this.props;
    const { openedBlocks } = this.state;

    return (
      <div className={classes.justifyCenter}>
        <div style={{ margin: '30px 30px 100px 30px', backgroundColor: '#fff', maxWidth: '900px', width: '900px', minWidth: '50vw' }}>

          <div id='#sylectus' className={classes.m30}>
            {this.blockTitle("Automatic loads sending setting from Sylectus", '#sylectus', '/images/sylectus.svg')}

            {openedBlocks && openedBlocks.has('#sylectus') ?
              <div className={`${classes.flexRow} ${classes.ml5} ${classes.pb60}`}>
                <div className={classes.blockLine}></div>
                
                <div className={classes.ml10}>
                  <SylectusRedirect
                    classes={classes}
                    arrowRight={this.arrowRight}
                    mwDashboard={this.mwDashboard}
                    settingsIcon={this.settingsIcon}
                    sylectusMessage={this.sylectusMessage}
                    verificationMessage={this.verificationMessage}
                    autogeneratedMWEmail={this.autogeneratedMWEmail}
                  />
                  
                </div>
              </div>
            : null}
          </div>

          <div id='#gmail' className={classes.m30}>
            {this.blockTitle("Gmail Automatic loads forwarding setting", '#gmail', '/images/gmail.svg')}

            {openedBlocks && openedBlocks.has('#gmail') ?
              <div className={`${classes.flexRow} ${classes.ml5} ${classes.pb60}`}>
                <div className={classes.blockLine}></div>
                
                <div className={classes.ml10}>
                  <GmailRedirect
                    classes={classes}
                    arrowRight={this.arrowRight}
                    settingsIcon={this.settingsIcon}
                    verificationMessage={this.verificationMessage}
                    autogeneratedMWEmail={this.autogeneratedMWEmail}
                  />
                </div>
              </div>
            : null}
          </div>

          <div id='#gmail_filter' className={`${classes.m30}`}>
            {this.blockTitle("Setting Filter for Gmail forwarding (on Sylectus example)", '#gmail_filter', null)}

            {openedBlocks && openedBlocks.has('#gmail_filter') ?
              <div className={`${classes.flexRow} ${classes.ml5} ${classes.pb60}`}>
                <div className={classes.blockLine}></div>

                <div className={`${classes.descriptionFont} ${classes.ml10}`}>
                  <li>1. Go to "Settings"</li>
                  <li className={`${classes.mt10} ${classes.mb10}`}>
                    <img
                      src="/images/gmail_settings.png"
                      title="gmail_settings"
                      alt="gmail_settings"
                      style={{
                        width: '250px',
                        height: 'auto',
                      }}
                    />
                  </li>
                  <li>2. Go to "Filters and Blocked Addresses" tab and create new filter.</li>
                    <img
                      src="/images/gmail_filter3.png"
                      title="gmail_filter3"
                      alt="gmail_filter3"
                      style={{
                        width: '500px',
                        height: 'auto',
                      }}
                    />
                  <li>3. Paste "postedloads@sylectus.com" (or your desired load board email address for filtering) into "Doesn't have" field.</li> 
                    <li>If you want to exclude multiple domains, separate them with a space. For example: @example.com @anotherdomain.com .</li>
                    <li>Click "Create filter".</li>
                    <li className={`${classes.mt10} ${classes.mb10}`}>
                      <img
                        src="/images/gmail_filter2.png"
                        title="gmail_filter2"
                        alt="gmail_filter2"
                        style={{
                          width: '500px',
                          height: 'auto',
                        }}
                      />
                  </li>
                  <li className={classes.alignCenter}>4. At "Forward it to option" select &nbsp;{this.autogeneratedMWEmail()} &nbsp;&nbsp; address from the list (or add forwarding address).</li>
                  <li>Click "Create filter".</li>
                  <li className={`${classes.mt10} ${classes.mb10}`}>
                    <img
                      src="/images/gmail_filter1.png"
                      title="gmail_filter1"
                      alt="gmail_filter1"
                      style={{
                        width: '500px',
                        height: 'auto',
                      }}
                    />
                  </li>
                  <li>From here, the messages that come to your Gmail will be filtered by the rule you selected and forwarded to your Milkyweb account.</li>

                  <div className={`${classes.mt20} ${classes.descriptionFont}`}>
                    <li>If you have any issues following the instruction, contact our support team via chat at the right bottom of the page or email <i>support@milkyweb.net</i></li>
                  </div>
                </div>
              </div>
            : null}
          </div>

          <div id='#microsoft365' className={`${classes.m30}`}>
            {this.blockTitle("Microsoft 365 automatic forwarding setting", '#microsoft365', '/images/microsoft-365.svg')}

            {openedBlocks && openedBlocks.has('#microsoft365') ?
              <div className={`${classes.flexRow} ${classes.ml5} ${classes.pb60}`}>
                <div className={classes.blockLine}></div>
              
                <div className={classes.ml10}>
                  <MicrosoftRedirect
                    classes={classes}
                    autogeneratedMWEmail={this.autogeneratedMWEmail}
                  />
                </div>
              </div>
            : null}
          </div>

          <div id='#yahoo' className={`${classes.m30}`}>
            {this.blockTitle("Yahoo automatic forwarding setting", '#yahoo', '/images/yahoo.png')}

            {openedBlocks && openedBlocks.has('#yahoo') ?
              <div className={`${classes.flexRow} ${classes.ml5} ${classes.pb60}`}>
                <div className={classes.blockLine}></div>
              
                <div className={classes.ml10}>
                  <YahooRedirect
                    classes={classes}
                    arrowRight={this.arrowRight}
                    settingsIcon={this.settingsIcon}
                    verificationMessage={this.verificationMessage}
                    autogeneratedMWEmail={this.autogeneratedMWEmail}
                  />
                </div>
                
              </div>
            : null}
          </div>

          <div id='#outlook' className={`${classes.m30}`}>
            {this.blockTitle("Outlook automatic loads forwarding setting", '#outlook', '/images/outlook.png')}

            {openedBlocks && openedBlocks.has('#outlook') ?
              <div className={`${classes.flexRow} ${classes.ml5} ${classes.pb60}`}>
                <div className={classes.blockLine}></div>

                <div className={classes.ml10}>
                  <OutlookRedirect
                    classes={classes}
                    arrowRight={this.arrowRight}
                    settingsIcon={this.settingsIcon}
                    verificationMessage={this.verificationMessage}
                    autogeneratedMWEmail={this.autogeneratedMWEmail}
                  />
                </div>
              </div>
            : null}
          </div>

          <div id='#billing' className={`${classes.m30}`}>
            {this.blockTitle("Billing", '#billing', null)}

            {openedBlocks && openedBlocks.has('#billing') ?
            <React.Fragment>
              <div className={`${classes.flexRow} ${classes.ml5} ${classes.pb30}`}>
                <div className={classes.blockLine}></div>

                <div className={`${classes.ml10} ${classes.descriptionFont}`}>
                  <li><strong>1. How We Calculate Your Charges</strong></li>
                  <li>We charge based on the number of drivers participating in matching each month.</li>
                  <li>
                    Drivers in the database without assigned zip codes during the month are excluded from the invoice.
                  </li>

                  <li className={`${classes.mt10} ${classes.ml20}`}><strong>Examples:</strong></li>
                  <li className={classes.ml30}>- 5 drivers participated in matching: $50 ($10 per driver, when &lt; 10 drivers/month).</li>
                  <li className={classes.ml30}>- 14 drivers participated in matching: $112 ($8 per driver, when &gt; 11 but &lt; 50 drivers/month, (with $100 minimum charge)).</li>
                  <li>
                    To explore how pricing is calculated based on your truck usage and the features included, visit our&nbsp;
                      <a target="_blank" rel="noreferrer" href={`https://www.milkyweb.ai/#Pricing2`}
                        className={`${classes.providersText} ${classes.pointer}`}
                      ><span className={classes.pointer}>Pricing</span><OpenInNewRoundedIcon className={classes.iconInfo}/></a>
                    &nbsp;for a detailed breakdown.
                  </li>
                </div>
              </div>

                <div className={`${classes.flexRow} ${classes.ml5} ${classes.pb30}`}>
                  <div className={classes.blockLine}></div>
                
                  <div className={`${classes.ml10} ${classes.descriptionFont}`}>
                    <li><strong>2. Free Plan Restrictions</strong></li>
                    <li>If the previous month's balance is unpaid, your account will automatically switch to the Free Plan. While still active, the Free Plan has the following restrictions:</li>
              
                    <li className={`${classes.mt10} ${classes.ml20}`}>
                      <strong>Matching:</strong> Limited to 3 trucks per month.
                    </li>
                    <li className={`${classes.ml20}`}>
                      <strong>Drivers:</strong> One zip update is accessible every 24 hours.
                    </li>
                    <li className={classes.ml20}>
                      <strong>Email Processing:</strong> Only supports Sylectus emails.
                    </li>
                    <li className={classes.ml20}>
                      <strong>Email Branding:</strong> Bidding emails include the Milkyweb.ai footer.
                    </li>
              
                    <li className={`${classes.mt10} ${classes.mb10} ${classes.p10}`} style={{ backgroundColor: '#EEECF8' }}>
                      <strong>Pro Tip:</strong><br />
                      <span>- Check 'Balance' on the top-right corner of your Milkyweb pages header for reminders, current usage, due and balance.</span><br />
                      <span>- Avoid restrictions by refilling your balance before the due date.</span><br />
                      <span>- Track your current month's usage to estimate your upcoming bill and cover it in advance.</span>
                    </li>
                  </div>
                </div>

                <div className={`${classes.flexRow} ${classes.ml5} ${classes.pb60}`}>
                  <div className={classes.blockLine}></div>

                  <div className={`${classes.ml10} ${classes.descriptionFont}`}>
                    <li><strong>3. When Payments Are Due</strong></li>
                    <li>Billing Cycle: Payments for each month are processed at the beginning of the following month.</li>
                    
                    <li className={`${classes.mt10} ${classes.ml20}`}>
                      <strong>Example:</strong> November's charges will be deducted at the start of December.
                    </li>
                    <li className={classes.ml20}>
                      <strong>Advance Payments:</strong> You can top up your account at any time to cover upcoming charges.
                    </li>
                  </div>
                </div>
              </React.Fragment>
            : null}
          </div>
        </div>
      </div>
    )
  }
};

export default withStyles(styles)(UserTutorialPage);
